module.exports = __webpack_public_path__ + "img/trending-up.0c98e5b3.svg";